import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportCells4GFdd, exportCells4GTdd, exportCells5G } from '@api/exportCells';

import { IExportCellsDTO } from '@interfaces/cells/dto/cellsDTO';

import { ESnackbarTypes, ETechnologiesValues, TTechnologiesValues } from '@enums/common';

import { EXPORT_CELLS_BY_TECHNOLOGY } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

type TExportTechnologyCellsMutation = {
	dto: IExportCellsDTO;
	technologyValue: TTechnologiesValues;
};

export const useMutateExportCells = () => {
	const dispatch = useAppDispatch();

	const {
		mutate: handlePreparingExportCellsByTechnology,
		isLoading: isLoadingExportCellsByTechnology,
	} = useMutation<TExportTechnologyCellsMutation>({
		mutationKey: [EXPORT_CELLS_BY_TECHNOLOGY],
		mutationFn: ({ technologyValue, dto }: TExportTechnologyCellsMutation) => {
			switch (technologyValue) {
				case String(ETechnologiesValues.T_4G_TDD):
					return exportCells4GTdd(dto);
				case String(ETechnologiesValues.T_4G_FDD):
					return exportCells4GFdd(dto);
				case String(ETechnologiesValues.T_5G):
					return exportCells5G(dto);
				default:
					return Promise.resolve({});
			}
		},
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportStartingSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return {
		handlePreparingExportCellsByTechnology,
		isLoadingExportCellsByTechnology,
	};
};
